export const statusOptions = [
  { value: 'activo', es: 'Activo', en: 'Active' },
  { value: 'finalizado', es: 'Finalizado', en: 'Completed' },
  { value: 'cancelado', es: 'Cancelado', en: 'Cancelled' },
];

export const productTypes = [
  { value: 'cosmetico', es: 'Cosmético', en: 'Cosmetic' },
  { value: 'cosmetico_plus', es: 'Cosmético Plus', en: 'Cosmetic Plus' },
  { value: 'sanitario', es: 'Producto sanitario', en: 'Medical Device' },
  { value: 'suplemento', es: 'Suplemento alimenticio', en: 'Supplement' },
  { value: 'medicamento', es: 'Medicamento', en: 'Drug' },
];

export const catLabels = { tolerancia: 'Tolerancia', eficacia: 'Eficacia', seguridad: 'Seguridad', dermatologia: 'Dermatologia', satisfaccion: 'Satisfaccion', general: 'General' };
export const catColors = { tolerancia: 'bg-amber-50 text-amber-700 border-amber-200', eficacia: 'bg-green-50 text-green-700 border-green-200', seguridad: 'bg-red-50 text-red-700 border-red-200', dermatologia: 'bg-cyan-50 text-cyan-700 border-cyan-200', satisfaccion: 'bg-violet-50 text-violet-700 border-violet-200', general: 'bg-stone-50 text-stone-600 border-stone-200' };

export const STAFF_ROLES = [
  { key: 'director_estudio', label_es: 'Director Estudio', label_en: 'Study Director' },
  { key: 'investigador_principal', label_es: 'Investigador Principal', label_en: 'Principal Investigator' },
  { key: 'investigador', label_es: 'Co-Investigador', label_en: 'Co-Investigator' },
  { key: 'monitor', label_es: 'Monitor', label_en: 'Monitor' },
  { key: 'coordinador', label_es: 'Coordinador', label_en: 'Coordinator' },
  { key: 'data_manager', label_es: 'Data Manager', label_en: 'Data Manager' },
  { key: 'responsable_sondas', label_es: 'Responsable de Sondas', label_en: 'Probes Lead' },
  { key: 'sondas', label_es: 'Sondas', label_en: 'Probes' },
  { key: 'responsable_reclutamiento', label_es: 'Responsable de Reclutamiento', label_en: 'Recruitment Lead' },
  { key: 'reclutamiento', label_es: 'Reclutamiento', label_en: 'Recruitment' },
];

export const sampleStatusColors = {
  recibido: 'bg-blue-50 text-blue-700 border-blue-200',
  en_uso: 'bg-green-50 text-green-700 border-green-200',
  agotado: 'bg-stone-50 text-stone-600 border-stone-300',
  devuelto: 'bg-amber-50 text-amber-700 border-amber-200',
  destruido: 'bg-red-50 text-red-600 border-red-200',
};

export const storageLabelsStudy = {
  es: { ambiente: 'T° Ambiente', refrigerado: 'Refrigerado (2-8°C)', congelado: 'Congelado (-20°C)', ultra_congelado: 'Ultra-congelado (-80°C)' },
  en: { ambiente: 'Room temp', refrigerado: 'Refrigerated (2-8°C)', congelado: 'Frozen (-20°C)', ultra_congelado: 'Ultra-frozen (-80°C)' },
};
